import styles from "./NotificationSteps.module.scss";

/**
 * Where staff turn on notifications for new reservations in the classes they lead:
 * the menu → the three dots next to their name → "Моят профил" → "Известия".
 */
export const NewReservationsSteps = () => (
  <ol className={styles.steps}>
    <li>
      <span>Отворете менюто</span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 7h16M4 12h16M4 17h16" />
      </svg>
    </li>
    <li>
      <span>
        Натиснете трите точки до името си и изберете <b>„Моят профил“</b>
      </span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="5" r="1" />
        <circle cx="12" cy="12" r="1" />
        <circle cx="12" cy="19" r="1" />
      </svg>
    </li>
    <li>
      <span>
        Превъртете до <b>„Известия“</b> и в „Нови резервации“ включете{" "}
        <b>„Известие на устройството“</b>
      </span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="2.5" y="7" width="19" height="10" rx="5" />
        <circle cx="16.5" cy="12" r="2.5" />
      </svg>
    </li>
  </ol>
);
